import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import storage from "../../Services/Storage";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Fa from "react-icons/fa";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { Calendar } from "primereact/calendar";
import { createAPIEndpointDiscountDefinition, EndpointDiscountDefinition } from "../../Services/DiscountDefinition/DiscountDefinitionService";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import Loader from "../../Components/Loader";

const DiscountDefinition = () => {
    // const location = useLocation();
    // const { discountData, jsonData } = location?.state;
    // const discountData = location?.state.data;
    // const jsonData = location?.state.json;
    const nav = useNavigate();
    const [searchParam] = useSearchParams();
    const auth = storage.getLocal("user");
    const DISCOUNT_ID = searchParam.get("DISCOUNT_ID");
    const [productData, setProductData] = useState([]);
    const [discountName, setDiscountName] = useState();
    const [discountType, setDiscountType] = useState("Percentage");
    const [visible, setVisible] = useState(false);
    const [existingProdList, setExistingProdList] = useState([]);
    const [loader,setLoader] = useState(false);
    // const [jsonData, setJsonData] = useState([]);

    
    const GetExistingDisc = async () => {
        setLoader(true);
        try{
            const res = await createAPIEndpointDiscountDefinition().get(`${EndpointDiscountDefinition.GetExistingDisc}?DiscountId=${DISCOUNT_ID}&CompId=${auth.CompId}`);
            console.log(res);
            setProductData(res?.data?.ProdData);
            setDiscountName(res?.data?.Data[0]?.DISCOUNT_NAME);
            setExistingProdList(res?.data?.ProdData);
            if(res.data.Data[0].PERC_TAG==="Y"){
                setDiscountType("Percentage");
            }
            else{
                setDiscountType("Value");
            }
        }catch(ex){
            console.log(ex);
        }finally{
            setLoader(false);
        }
    };

    const getSaveDataPayload = () => {
        console.log(discountName,discountType,"discount");
        if(discountName===undefined||discountName===""){
            toast.error("Please provide discount name", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                pauseOnFocusLoss: false,
                closeButton: false
            });
            return;
        }
        if(productData===null||productData===undefined||productData.length===0){
            toast.error("No products available", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                pauseOnFocusLoss: false,
                closeButton: false
            });
            return;
        }
        const filteredResult = productData.filter((row) => {
            return row.Discount > 0;
        });
        console.log(filteredResult,"filteredResult");
        // setFileteredProductData(filteredResult);
        if(filteredResult.length>0){
            saveData(filteredResult);
        }
        else{
            toast.error("Please define discount for Product(s)", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                pauseOnFocusLoss: false,
                closeButton: false
            });
        }
    };

    const validateRows = (filteredResult) => {
        console.log("filteredResult ", filteredResult);
        for (let i = 0; i < filteredResult.length; i++) {
            const row = filteredResult[i];

            if (!row["Product Code"]) {
                showErrorToast("Product ID cannot be empty");
                return false;
            }

            if (!discountName) {
                showErrorToast("Discount name cannot be empty");
                return false;
            }

            const discountValue = row.DISCOUNT;
            if (discountValue > 0) {
                showErrorToast("Discount value should be a greater than zero");
                return false;
            }

            const startDate = row["Start Date"];
            const endDate = row["End Date"];

            // if (!startDate || !Date.parse(startDate)) {
            //     showErrorToast('Start Date is not valid');
            //     return false;
            // }

            // if (!endDate || !Date.parse(endDate)) {
            //     showErrorToast('End Date is not valid');
            //     return false;
            // }

            const startDateObj = new Date(startDate);
            const endDateObj = new Date(endDate);
            if (startDateObj > endDateObj) {
                showErrorToast("Start Date should be less than End Date");
                return false;
            }
        }

        return true;
    };

    const showErrorToast = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER,
            pauseOnFocusLoss: false,
            closeButton: false,
            autoClose: 2000,
        });
    };
    const createPayload = (filteredResult) => {
        if (!validateRows(filteredResult)) {
            return;
        }
        console.log(DISCOUNT_ID,"DISCOUNT_ID");
        // debugger;
        if(DISCOUNT_ID!==""){
            return {
                compId: auth.CompId,
                discountId: DISCOUNT_ID,
                scope: "S",
                discountName: discountName,
                applicableTo: "U",
                status: "Y",
                userId: auth.UserId,
                percTag: discountType==="Percentage"?"Y":"N",
                iuKey: "2",
                lstDetails: filteredResult.map(row => ({
                    compId: auth.CompId,
                    discountId: "",
                    prodId: row["Product Code"],
                    discountPerc: row.Discount?.toString(),
                    fromDate: row["Start Date"],
                    toDate: row["End Date"],
                    status: "Y",
                    iuKey: existingProdList.some((a)=>a["Product Code"]===row["Product Code"])===true?"2":"1",
                }))
            };
        }else{
            return {
                compId: auth.CompId,
                discountId: "",
                scope: "S",
                discountName: discountName,
                applicableTo: "U",
                status: "Y",
                userId: auth.UserId,
                percTag: discountType==="Percentage"?"Y":"N",
                iuKey: "1",
                lstDetails: filteredResult.map(row => ({
                    compId: auth.CompId,
                    discountId: "",
                    prodId: row["Product Code"],
                    discountPerc: row.Discount?.toString(),
                    fromDate: row["Start Date"],
                    toDate: row["End Date"],
                    status: "Y",
                    iuKey: DISCOUNT_ID!==""?"2":"1",
                }))
            };
        }
        
    };

    const saveData = async (filteredResult) => {
        setLoader(true);
        const payload = createPayload(filteredResult);
        createAPIEndpointDiscountDefinition()
            .post(`${EndpointDiscountDefinition.SaveData}`, payload)
            .then(response => {
                console.log("Data saved successfully:", response.data);
                toast.success("Data saved successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    pauseOnFocusLoss: false,
                    closeButton: true,
                });
                nav("/masters/discountdefinition");
            })
            .catch(err => {
                console.error("Error occurred:", err);
                toast.error(`${err.response.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    pauseOnFocusLoss: false,
                    closeButton: true,
                });
            }).finally(()=>{
                setLoader(false);
            });
    };

    const handleChange = (e) => {
        setDiscountName(e.target.value);
    };
    const handleExport = async () => {
        try {
            let date = new Date();
            let day = date.getDate();
            let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let exactmonths = months[date.getMonth()];
            let year = date.getFullYear();
            let uniqueNo = Math.floor(Math.random() * 10000);
            const response = await createAPIEndpointDiscountDefinition().get(`${EndpointDiscountDefinition.ExportData}?CompId=${auth.CompId}&DiscountId=${""}`);
            if (response.data && response.data.length > 0) {
                downloadExcel(response.data,`DiscountDef_${day}${exactmonths}${year}_${uniqueNo}.xlsx`);
            } else {
                toast.error("No data available to export!", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        } catch (err) {
            toast.error(err.message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
    };
    // const ProdValidation = async(result) => {
    //     try{
    //         const maskIds = result.map((val) => `${val["Product Code"]}`).join(",");
    //         const res = await createAPIEndpointDiscountDefinition().get(`${EndpointDiscountDefinition.ProdValidation}?CompId=${auth.CompId}&ProdCode=${maskIds}`);
    //         console.log(res,"ProdValidation");
    //     }catch{
    //         return false;
    //     }
    // }
    const handleFileUpload = (e) => {
        console.log("file is selected ", e);

        const file = e.files;

        file.forEach(file => {
            if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                alert("Only Excel (.xlsx) files are supported.");
                return;
            }
            const reader = new FileReader();
    
            reader.onload = (e) => {
                const arrayBuffer = e.target.result;
                const workbook = XLSX.read(arrayBuffer, { type: "array" });
    
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    
                const data = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });
                const headers = data[0];
                const rows = data.slice(1).filter(row => row.some(cell => cell !== null));
                const convertExcelDate = (dateNum) => {
                    const baseDate = new Date(1900, 0, 1);
                    const date = new Date(baseDate.getTime() + (dateNum - 2) * 86400000);
                    return date;
                };
    
                const formatDate = (date) => {
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const year = date.getFullYear();
                    return `${day}/${month}/${year}`;
                };
    
                const result = rows.map(row => {
                    let obj = {};
                    row.forEach((cell, index) => {
                        const header = headers[index];
                        if (header.includes("Date") && !isNaN(cell)) {
                            const dateObj = convertExcelDate(cell);
                            obj[header] = formatDate(dateObj);
                        } else {
                            obj[header] = cell;
                        }
                    });
                    return obj;
                });
                console.log(result,"result");
                // setJsonData([result]);
                // ProdValidation(result);
                setProductData(result);
                setVisible(false);
            };
    
            reader.readAsArrayBuffer(file);
        });
    };
    const editableTextEditor = (rowData) => {
        return (
        // <InputText
        //     value={rowData['Discount']}
        //     onChange={(e) => onEditorValueChange(rowData, e.target.value)}
        // />
            <InputNumber
                value={rowData["Discount"]}
                onValueChange={(e) => onEditorValueChange(rowData, e.target.value)}
                mode="decimal"
                min={0} // <-- No negative values
                maxFractionDigits={2} // <-- Allow 2 digits after decimal point
                placeholder="Enter decimal"
            />
        );
    };
    const onEditorValueChange = (rowData, value) => {
        const updatedProducts = [...productData];
        const index = productData.findIndex(item => item["Product Code"] === rowData["Product Code"]);
        updatedProducts[index]["Discount"] = value;  // <-- update specific field
        console.log(updatedProducts,"updatedProducts");
        setProductData(updatedProducts);
    };
    const onDateChange = (rowData, field, value) => {
        const updatedProducts = [...productData];
        const index = productData.findIndex(item => item["Product Code"] === rowData["Product Code"]);
        updatedProducts[index][field] = value;
        setProductData(updatedProducts);
    };
      
    const dateEditor = (rowData, field) => {
        const handleChange = (e) => {
            const selectedDate = e.value;

            if (selectedDate) {
                const day = String(selectedDate.getDate()).padStart(2, "0");
                const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
                const year = selectedDate.getFullYear();
        
                const formattedDate = `${day}/${month}/${year}`;
        
                onDateChange(rowData, field, formattedDate); // Save back as formatted string
            }
        };
        const startDate = parseDate(rowData["Start Date"]);
        const endDate = parseDate(rowData["End Date"]);
        return (
            <Calendar
                value={rowData[field] ? parseDate(rowData[field]) : null}
                onChange={handleChange}
                dateFormat="dd/mm/yy"
                showIcon
                placeholder="Select Date"
                readOnlyInput
                minDate={field === "End Date" ? startDate : null}
                maxDate={field === "Start Date" ? endDate : null}
            />
        );
    };
    const parseDate = (dateString) => {
        if (!dateString) return null;
      
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Month is 0-based in JS
        const year = parseInt(parts[2], 10);
      
        return new Date(year, month, day);
    };
    useEffect(() => {
        // if (location.state.json) {
        //     setProductData(location.state.json);
        //     setTableHeader(false);

        // } 
        if(DISCOUNT_ID!=="") {
            // setDiscountName(discountData.DISCOUNT_NAME);
            // setTableHeader(true);
            // getProductData();
            GetExistingDisc();
        }
    }, []);
    if(loader){
        return(<Loader/>);
    }
    else{
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mx-1">
                                    <li className="breadcrumb-item">
                                        <Link to="/masters/discountdefinition/details">Discount Definition</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Details</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end mb-2">
                                <Link to="/masters/discountdefinition">
                                    <button type="button" className="btn btn-outline-primary me-3">
                                        <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All Records
                                    </button>
                                </Link>
                                <button type="button" className="btn btn-outline-primary me-3" onClick={handleExport}>
                                Export <Fa.FaFileExport className="ms-2" />
                                </button>
                                <button type="button" className="btn btn-outline-primary me-3" onClick={()=>{setVisible(true);}}>
                                Import <Fa.FaFileImport className="ms-2" />
                                </button>
                                <button type="submit" className="btn btn-primary" onClick={getSaveDataPayload}>Save</button>
                            </div>
                        </div>
                    </div>
                    <section className="sales-box">
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="d-block">
                                    <label className="form-label">Discount Name <span className="mandatory">*</span></label>
                                    <InputText className="form-control" onChange={(e) => handleChange(e)}
                                        value={discountName} placeholder="" required disabled={DISCOUNT_ID!==""?true:false}/>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="d-block">
                                    <label className="form-label">Discount Type</label>
                                    <div className="flex flex-wrap gap-3">
                                        <div className="flex d-inline-flex">
                                            <RadioButton name="DiscType" value="Percentage" onChange={(e)=>setDiscountType(e.value)} // Handle change
                                                checked={discountType === "Percentage"} />
                                            <label className="ms-2">Percentage</label>
                                        </div>
                                        <div className="flex d-inline-flex ms-3">
                                            <RadioButton name="DiscType" value="Value"
                                                onChange={(e)=>setDiscountType(e.value)} // Handle change
                                                checked={discountType === "Value"} />
                                            <label className="ms-2">Value</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <h3>Records</h3>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className="DataTable">
                                <DataTable
                                    rows={10}
                                    value={productData}
                                    filterDisplay="row"
                                    // showGridlines
                                    stripedRows
                                    scrollHeight="80vh"
                                    scrollable
                                    paginator
                                    editMode="cell"
                                >
                                    <Column field="Product Code" header="Product Code" filter filterMatchMode="contains" filterPlaceholder="Search Here..."/>
                                    <Column field="Product Desc" header="Product Description" filter filterMatchMode="contains" filterPlaceholder="Search Here..."/>
                                    <Column field="Discount" header="Discount" body={editableTextEditor}/>
                                    <Column field="Start Date" header="Start Date" body={(rowData) => dateEditor(rowData, "Start Date")} />
                                    <Column field="End Date" header="End Date" body={(rowData) => dateEditor(rowData, "End Date")} />
                                </DataTable>
                            </div>
                        </div>
                    </section>
                    <div>
                        <Dialog
                            header="Upload File"
                            visible={visible}
                            onHide={()=>setVisible(false)}
                            style={{ width: "50vw" }}
                            modal
                        >
                            <FileUpload accept=".xlsx" customUpload
                                single="true"
                                uploadHandler={handleFileUpload}
                                emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>} />
                        </Dialog>
                    </div>
                </div>
            </>
        );
    }
};

export default DiscountDefinition;